<template>
    <div class="container">
        <div class="page page-setting">
            <div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Popup Information') }}</h1>
						<div>Atur slider information untuk ditampilkan di halaman depan</div>
					</div>
					<div class="col-md-3">
						<div @click="isCreateVisible = true" class="page-header-right text-right">
							<button class="btn btn-primary" :disabled="isLoading">Add Popup Information</button>
						</div>
					</div>
				</div>
			</div>

            <div class="page-content">

				<FormInformation v-if="isCreateVisible" :is-loading="isCreatedLoad" @close="isCreateVisible = false" @submit="submit" />

                <div v-if="isLoading" class="is-loading"></div>

                <draggable
                    v-if="!isLoading"
                    v-model="informations"
                    @end="onDraggedEnd"
					handle=".drag-item"
                >
                    <div class="card card-body card-information-container mb-4" v-for="(information, i) in informations" :key="i">
						<div v-if="information" class="d-flex card-information-header">
							<button class="btn btn-sm btn-plain drag-item" v-tooltip="'Drag to order'">
								<i class="bi-grip-vertical"></i>
							</button>
							<span v-if="information && information.title" class="information-title align-self-center mr-auto">
								{{ information.title }}
							</span>
							<checkbox-toggle class="mt-1" :value="information.is_active" :toggle-info="information.is_active ? 'Deactivate' : 'Activate'" @input="toggleStatus($event, information)" />
							<button class="btn btn-sm btn-plain" v-tooltip="'Remove this information'" @click="showRemoveModal(information._id)">
								<i class="bi-x-lg"></i>
							</button>
							<button class="btn btn-sm btn-plain drag-item" v-tooltip="'Click to expand'" data-toggle="collapse" :data-target="`#section${information._id}`" aria-expanded="false" :aria-controls="`section${information._id}`" @click="isCollapsed = !isCollapsed">
								<i v-if="!isCollapsed" class="bi-chevron-down"></i>
								<i v-if="isCollapsed" class="bi-chevron-up"></i>
							</button>
						</div>
						<div v-if="information" class="p-2">
							<div>
								<span>
									Type : <small class="badge badge-primary">{{ getInfoType(information.type) }}</small>
								</span>
							</div>
							<div>
								<span class="text-capitalize">
									Visibility : <b>{{ information.target === 'seler_supliers' ? 'Seller & Supplier' : information.target }}</b>
								</span>
							</div>
							<div>
								<span>
									Created At : <b>{{ setTime(information.created_at, 'YYYY-MM-DD') }}</b>
								</span>
							</div>
						</div>
						<div v-if="information" class="collapse" :id="`section${information._id}`">
							<hr>
							<div v-if="!information.isEdit" class="card-body">
								<div v-if="information.picture && information && information.type === 'image_text'" class="mt-4">
									<img :src="information.picture">
								</div>
                                <div class="mt-4">
                                    <div><span>Content:</span></div>
                                    <div v-html="formatDesc(information.description)" />
                                </div>
								<strong v-if=information.url>Link to : {{ information.url }}</strong>
								<div class="mt-4">
								<button class="btn btn-outline outline-primary btn-sm" @click="showPreview(information)">
									Preview Modal
								</button>
								<button class="btn btn-outline outline-primary btn-sm ml-2" @click="information.isEdit = !information.isEdit">
									Update Modal
								</button>
							</div>
							</div>
							<FormInformation
								v-if="information.isEdit"
								:config="information"
								:is-loading="isUpdated"
								@close="information.isEdit = false"
								formType="edit"
								@submit="submit"
							/>
						</div>
					</div>
                </draggable>

				<div v-if="!isLoading && informations.length === 0">
					<div class="border rounded p-5">
						<div class="d-flex justify-content-center">
							<span>
								Tidak ada Configurasi Popup Informasi
							</span>
						</div>
					</div>
				</div>
            </div>
        </div>
        <ModalConfirm
            v-if="isDeleteModalVisible"
            content="are you sure want to delete this Popup Information ?"
			title="Delete Popup Information"
			textBtn="Delete"
			btn-type="btn-danger"
			:is-loading="isDeleted"
            @close="isDeleteModalVisible = false"
            @submit="submitDelete"
        />
		<ModalPreview v-if="isModalPreviewVisible" :config="information"  @close="isModalPreviewVisible = false" />
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import ModalConfirm from '@/components/ModalConfirm.vue';
import { getData, moveInformation, deleteInformation, create, update } from '@/api/popup-information';
import mediaApi from '@/api/media';
import FormInformation from '@/components/pop-information/Form.vue';
import { nl2br, sanitizeHtml } from '@/lib/helper';
import ModalPreview from '@/components/pop-information/ModalPopup.vue';
import CheckboxToggle from '@/components/CheckboxToggle.vue';

const dayjs = require('dayjs');
const utcPlugin = require('dayjs/plugin/utc');
const timezonePlugin = require('dayjs/plugin/timezone');

// Extend dayjs with plugins
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

export default {
	name: 'AdminPopupInformation',
	components: {
		ModalConfirm,
		draggable,
		FormInformation,
		ModalPreview,
		CheckboxToggle,
	},
	data() {
		return {
			informations: [],
			isLoading: false,
			isAll: false,
			page: 1,
			isDeleteModalVisible: false,
			isCreateVisible: false,
			informationId: null,
			previewImage: '',
			stateUpload: '',
			isUploading: false,
			title: '',
			release_date: '',
			type: 'text',
			image: null,
			isUpdated: false,
			isCreatedLoad: false,
			information: null,
			isDeleted: false,
			isModalPreviewVisible: false,
			isCollapsed: false,
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: 10,
			};

			return params;
		},
	},
	created() {
		this.getDataInformations();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		getDataInformations() {
			const params = this.fetchParams;
			this.isLoading = true;
			const callback = (res) => {
				const data = res?.data;
				this.informations = data.map(info => ({
					...info,
					isEdit: false,
				}));
				this.isLoading = false;
			};

			const err = (e) => {
				console.log(e);
				const message = e.response.data.message;
				this.notify({
					title: 'Popup Information',
					text: message,
					type: 'error',
				});
				this.isLoading = false;
			};

			getData(params, callback, err);
		},
		handleScroll(event) {
			const elem = event.target;
			const height = elem.offsetHeight;
			const scrollTop = elem.scrollTop;
			const scrollHeight = elem.scrollHeight;
			const offset = 10;
			const isOnBottom = (scrollTop + height + offset) >= scrollHeight;
			if (isOnBottom && !this.isAll && !this.isLoading) {
				// this.fetchNotifications();
				this.page = this.page++;
			}
		},
		hideInformation(information) {
			const index = this.informations.findIndex(info => info?._id === information?._id);
			if (index !== -1) {
				this.informations[index].is_active = this.informations[index].is_active;
			}
		},
		toggleStatus(value, information) {
			this.updateInformation({ is_active: value }, information._id);
		},
		onDraggedEnd(value) {
			const currentInformation = this.informations[value?.newIndex];
			const newIndex = value?.newIndex;
			const params = {
				new_position: newIndex,
			};

			const callback = (res) => {
				const data = res?.data;
				if (data?.status === 200) {
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Popup Information',
						text: 'Popup Information Move Successfully',
					});
				}
			};

			const err = (e) => {
				const message = e.response.data.message;
				this.notify({
					title: 'Popup Information',
					text: message,
					type: 'error',
				});
			};

			moveInformation(currentInformation?._id, params, callback, err);
		},
		showRemoveModal(informationId) {
			this.informationId = informationId;
			this.isDeleteModalVisible = !this.isDeleteModalVisible;
		},
		uploadImage(state) {
			console.log('up');
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onInputImageChange(event) {
			this.image = '';
			this.previewImage = '';
			this.isUploading = true;
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'popup-information',
						text: noticeMessage,
						type: 'warn',
					});
					this.isUploading = false;
					this.isUploadingMobile = false;
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;
					this.image = url;
					this.previewImage = url;
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		submitDelete() {
			this.isDeleted = true;
			const informationId = this.informationId;
			const callback = (res) => {
				const data = res?.data;
				const index = this.informations.findIndex(curr => curr?._id === this.informationId);
				if (data.status && index !== -1) {
					this.isDeleted = false;
					this.informations.splice(index, 1);
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Popup Information',
						text: 'Popup Information Deleted Successfully',
					});
					this.isDeleteModalVisible = false;
				}
			};
			deleteInformation(informationId, callback);
		},
		submit(form, type, infoId) {
			if (type === 'create') {
				this.createInformation(form);
			} else if (type === 'edit') {
				this.updateInformation(form, infoId);
			}
		},
		updateInformation(form, infoId) {
			this.isUpdated = true;
			const callback = (res) => {
				const data = res?.data;
				this.isUpdated = false;
				if (data) {
					const index = this.informations.findIndex(curr => curr?._id === data?._id);
					if (index !== -1) {
						Object.keys(data).forEach((key) => {
							if (Object.prototype.hasOwnProperty.call(data, key)) {
								this.informations[index][key] = data[key];
							}
						});
						this.informations[index].isEdit = false;
						this.$notify({
							group: 'app',
							type: 'success',
							title: 'Popup Information',
							text: 'Popup Information Updated Successfully',
						});
					}
				}
			};

			const err = (e) => {
				const message = e.response.data.message;
				this.notify({
					title: 'Popup Information',
					text: message,
					type: 'error',
				});
				this.isUpdated = false;
			};
			update(infoId, form, callback, err);
		},
		createInformation(form) {
			this.isCreatedLoad = true;
			const callback = (res) => {
				const data = res?.data;
				if (data) {
					this.isCreatedLoad = false;
					this.informations.push({ ...data, isEdit: false });
					this.isCreateVisible = false;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Popup Information',
						text: 'Popup Information Created Successfully',
					});
				}
			};

			const err = (e) => {
				const message = e.response.data.message;
				this.notify({
					title: 'Popup Information',
					text: message,
					type: 'error',
				});
				this.isCreatedLoad = false;
			};
			create(form, callback, err);
		},
		showPreview(information) {
			this.information = information;
			this.isModalPreviewVisible = !this.isModalPreviewVisible;
		},
		setTime(date, format) {
			return dayjs.utc(date).tz(this.user?.timezone).format(format);
		},
		formatDesc(description) {
			return sanitizeHtml(nl2br(description));
		},
		getInfoType(type) {
			let str = 'Text';
			if (type === 'image_text') {
				str = 'Image With Text';
			}

			return str;
		},
	},
};
</script>
<style lang="scss" scoped>
	.card-information-container {
		border: 2px solid #4D4D4D;
		border-radius: 10px;

		// .card-information-header {
		// 	border-bottom: 2px solid #ADB5BD;
		// 	padding-bottom: 20px;
		// }

		.information-title {
			font-weight: 700;
			font-size: 22px;
			line-height: 120%;
		}

		.drag-item {
			font-weight: 700;
			font-size: 16px;
		}

		label {
			font-weight: 700;
			font-size: 16px;
			line-height: 150%;
		}

		.form-control {
			border: 2px solid #1F1F1F61;
			height: calc(2.3em + 0.45rem + 2px);
		}

		.form-control-select {
			height: 55px !important;
		}

		.editor-content {
			height: 60px !important;
		}

		.pc-image-empty-promotion {
			height: 220px !important;
		}
	}

	/* Memberikan warna abu-abu pada opsi yang dinonaktifkan */
	select option:disabled {
		color: #888 !important;
	}

	/* Memberikan gaya khusus pada select yang belum dipilih */
	select:invalid {
		color: #999 !important;
	}

	/* Mengatur warna teks untuk opsi yang valid */
	select option:not(:disabled) {
		color: #000 !important;
	}

	.badge-sm {
		font-size: 12px;
		position: absolute;
		top: 16px;
	}
</style>
